import {
    SCHEDULE_REVIEW_DRAIN_MAX_ITERATIONS,
    SCHEDULE_REVIEW_DRAIN_PAGE_SIZE,
} from "./scheduleReview.constants";

export interface DrainPageResult {
    /** True when at least one row left the filtered set, so page 1 has fresh rows. */
    progressed: boolean;
}

interface DrainOptions<TRow> {
    fetchPage: (options: { page: number; limit: number }) => Promise<TRow[]>;
    processPage: (rows: TRow[]) => Promise<DrainPageResult>;
    pageSize?: number;
    maxIterations?: number;
}

/**
 * Walks every row currently matching a filter and hands each page to
 * `processPage`. Rows that leave the filter after processing shrink the set,
 * so the cursor restarts at page 1 after progress; when a page made no
 * progress (every row was skipped) the cursor steps forward past it instead
 * of spinning. Mirrors the accrual review "confirm all" drain.
 */
export async function drainFilteredTransactions<TRow>({
    fetchPage,
    processPage,
    pageSize = SCHEDULE_REVIEW_DRAIN_PAGE_SIZE,
    maxIterations = SCHEDULE_REVIEW_DRAIN_MAX_ITERATIONS,
}: DrainOptions<TRow>): Promise<{ pagesProcessed: number }> {
    let page = 1;
    let pagesProcessed = 0;
    for (let iteration = 0; iteration < maxIterations; iteration += 1) {
        const rows = await fetchPage({ page, limit: pageSize });
        if (rows.length === 0) {
            break;
        }
        const result = await processPage(rows);
        pagesProcessed += 1;
        page = result.progressed ? 1 : page + 1;
    }
    return { pagesProcessed };
}
